export default "__VITE_ASSET__iuoIK05A__"